<template>
  <div id="Faq">
    <div class="wrapper">
      <h1>Frequently Asked Questions</h1>
      <div class="line"></div>
      <div id="accordionContainer">
        <Accordion :accordionData="accordionData" />
        <h2>Traditional Season Membership</h2>
        <!-- <div class="line"></div> -->
        <Accordion
          :accordionData="accordionTraditionalData"
          unique-prefix="accordionFaqTraditional"
        />
        <h2>Flexible Season Membership</h2>
        <!-- <div class="line"></div> -->
        <Accordion
          :accordionData="accordionFlexData"
          unique-prefix="accordionFaqFlex"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { faqData } from "@/data/faqData";
import { faqFlexData } from "@/data/faqFlexData";
import { faqTraditionalData } from "@/data/faqTraditionalData";
import { TweenLite } from "gsap/dist/gsap";
import Accordion from "@/components/sections/Faq/Accordion";
export default {
  name: "CoreBenefits",
  components: {
    Accordion,
  },
  data() {
    return {
      accordionData: faqData(),
      accordionFlexData: faqFlexData(),
      accordionTraditionalData: faqTraditionalData(),
      selectedCategory: "",
      activeItemKey: "",
    };
  },
  methods: {
    itemClicked(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;
      if (currentActiveEle) {
        this.activeItemKey = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0,
        });
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight,
        });
      }
    },
  },
  // mounted() {
  //   if (this.accordionData && Object.keys(this.accordionData).length > 0) {
  //     this.selectedCategory = Object.keys(this.accordionData)[0];
  //   }
  //   if (this.accordionFlexData && Object.keys(this.accordionFlexData).length > 0) {
  //     this.selectedCategory = Object.keys(this.accordionFlexData)[0];
  //   }
  //   if (this.accordionTraditionalData && Object.keys(this.accordionTraditionalData).length > 0) {
  //     this.selectedCategory = Object.keys(this.accordionTraditionalData)[0];
  //   }
  // }
};
</script>

<style lang="scss" scoped>
#Faq {
  padding-block: 150px 100px;
  @media only screen and (max-width: $lg) {
    padding-block: 50px;
  }
  background-image: url("~@/assets/images/bgImage_navy.jpg");
  background-size: cover;
  @media only screen and (max-width: $lg) {
    /* width: 90%; */
  }
  .wrapper {
    width: 50%;
    @media only screen and (max-width: $xl) {
      width: 80%;
    }
    margin: auto;
  }
  h2 {
    font-family: "Antique Olive";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    /* identical to box height */

    text-transform: uppercase;

    /* light blue */

    color: #79bde8;
    margin: 50px 0 20px;
  }
  h1 {
    font-family: "Antique Olive";
    font-style: normal;
    font-weight: 700;
    font-size: 35px;
    line-height: 80%;
    text-transform: uppercase;
    color: #79bde8;
    text-align: center;
    @media only screen and (max-width: $md) {
      font-size: 25px;
      line-height: 1;
    }
  }
  .line {
    background-color: $yellow;
    width: 567px;
    height: 5px;
    margin: 15px auto 50px;
    @media only screen and (max-width: $md) {
      width: 80%;
    }
  }
  #accordionContainer .line {
    margin-bottom: 1px;
  }
}
</style>